/** EvolveRPG — system overrides. Fast-play, momentum-driven voice. */
export const systemEvoEn = {
  // NotFoundPage
  'system.notFound.seoTitle': 'Page Not Found',
  'system.notFound.heading': 'You’ve wandered off the map',
  'system.notFound.body': 'The page you’re looking for doesn’t exist — or it moved fast.',
  'system.notFound.returnCta': 'Back to EvolveRPG',

  // RouteErrorBoundary
  'system.error.unknownDisturbance': 'Something glitched on this page.',
  'system.error.seoTitle': 'Something Went Wrong',
  'system.error.heading': 'That didn’t load right',
  'system.error.body': 'Something unexpected broke this page. Try again, or head back to safer ground.',
  'system.error.returnCta': 'Back to EvolveRPG',

  // ErrorState (generic inline error card)
  'system.error.disturbanceTitle': 'Something Went Wrong',

  // DataState (DataError / DataEmpty defaults)
  'system.data.veilClouded': 'Data Unavailable',
  'system.data.scryingDark': 'Something broke fetching this content. Try again in a moment.',
  'system.data.archiveSilent': 'Nothing Here Yet',
  'system.data.stirsAsTwilightDeepens': 'Nothing here yet — check back as more content drops.',
}
